import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

export interface PipelineUIState {
  selectedPipelineId: string | null;
  isFullscreen: boolean;
  typeFilter: string;
  projectFilter: string;
}

const initialState: PipelineUIState = {
  selectedPipelineId: null,
  isFullscreen: false,
  typeFilter: '',
  projectFilter: '',
};

const pipelineSlice = createSlice({
  name: 'pipelineUI',
  initialState,
  reducers: {
    setSelectedPipeline(state, action: PayloadAction<string | null>) {
      state.selectedPipelineId = action.payload;
    },
    toggleFullscreen(state) {
      state.isFullscreen = !state.isFullscreen;
    },
    setPipelineTypeFilter(state, action: PayloadAction<string>) {
      state.typeFilter = action.payload;
    },
    setPipelineProjectFilter(state, action: PayloadAction<string>) {
      state.projectFilter = action.payload;
    },
  },
});

export const {
  setSelectedPipeline,
  toggleFullscreen,
  setPipelineTypeFilter,
  setPipelineProjectFilter,
} = pipelineSlice.actions;
export default pipelineSlice.reducer;
